import image1 from './image1.svg'
import image2 from './image2.svg'
import image3 from './image3.svg'
import image4 from './image4.svg'
import image5 from './image5.svg'
import image6 from './image6.svg'
import image7 from './image7.svg'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const confetti = require('./confetti.gif')

export { image1, image2, image3, image4, image5, image6, image7, confetti }
